<template>
  <div>
    <div>
      <div class="clearfix table-tools">
        <div class="buttons">
          <a-form layout='inline'>
            <a-form-item v-if="canSave">
            <a-button icon="plus" type="primary" @click="showEditModal()">新增教室</a-button>
            </a-form-item>
          </a-form>
        </div>
        <div class="search">
          <a-form layout='inline' @submit="searchList">
            <a-form-item>
              <a-tooltip placement="topLeft" >
                <template slot="title">
                  <span>所属校区</span>
                </template>
                <a-select allowClear v-model="searchData.studio_id" mode="multiple" :maxTagCount="1" :maxTagTextLength='5' showSearch :filterOption="filterOption" placeholder="请选择校区" style="width: 210px">
                  <a-select-option v-for="(d, index) of studios" :key="index" :value="d['studio_id']">{{ d['filter_name'] }}</a-select-option>
                </a-select>
              </a-tooltip>
            </a-form-item>
            <a-form-item>
              <a-tooltip placement="topLeft" >
                <template slot="title">
                  <span>教室名字</span>
                </template>
                <a-input allowClear v-model.trim="searchData.room_name" placeholder="教室名字" style="width: 160px"/>
              </a-tooltip>
            </a-form-item>
            <a-form-item v-if="canIndex">
              <a-button type="primary" html-type="submit" :loading="loading" @click="searchList">搜索</a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
      <div class="table">
        <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>
        <a-table size="middle" :pagination="false" :bordered='false' rowKey="room_id"
          :columns="columns" :dataSource="list" @change="handleChange">
          <template slot="index" slot-scope="text, record , index">
            <span>{{(index+1) + pageParams.perPage * (pageParams.currentPage - 1)}}</span>
          </template>
          <template v-if="canRead" slot="room_name" slot-scope="text,record">
            <span style="color:#00cca2;cursor:pointer;" @click="showEditModal(record)">{{text}}</span>
          </template>
          <template slot="status" slot-scope="text,record">
            <a-switch checkedChildren="开" unCheckedChildren="关" :checked="text === 1" @change="changeStatus(record)"/>
          </template>
          <template slot="action" slot-scope="text,record">
            <a v-if="canUpdate" href="javascript:;" @click="showEditModal(record)">编辑</a>
            <!-- <a-divider type="vertical" />
            <a href="javascript:;" @click="deleteItem(record)">删除</a> -->
          </template>
        </a-table>
      </div>
      <div class="page">
        <a-pagination
          :pageSizeOptions="pageSizeOptions"
          :total="pageParams.totalCount"
          showSizeChanger
          :pageSize="pageParams.perPage"
          v-model="current"
          @change="changePage"
          @showSizeChange="onShowSizeChange"
          :showTotal="total => `共 ${pageParams.totalCount.toLocaleString()}条 `"
        >
            <template slot='buildOptionText' slot-scope='props'>
              <span v-if="props.value!=='100'">{{props.value}}条/页</span>
              <span v-if="props.value==='100'">100条/页</span>
            </template>
          </a-pagination>
      </div>
    </div>
    <editModal v-if="editVisible" :isEdit='isEdit' :item="modalData"/>
  </div>
</template>

<script>
const columns = [
  { title: '#', width:'55px', scopedSlots: { customRender: 'index' }, key: 'index' },
  { title: '教室名字', dataIndex: 'room_name', key: 'room_name',sorter:()=>{},scopedSlots: { customRender: 'room_name' }},
  { title: '所属校区', dataIndex: 'studio_id', key: 'studio_id',sorter:()=>{}},
  { title: '容纳人数', dataIndex: 'room_people', key: '1' ,sorter:()=>{}},
  // { title: '教室成本', dataIndex: 'room_price', key: '2' },
  { title: '开课数', dataIndex: 'classes_count', key: '3' },
  { title: '状态', dataIndex: 'room_status', key: '11', width: 80, scopedSlots: { customRender: 'status' }},
  { title: '操作', key: 'operation', width: 46, scopedSlots: { customRender: 'action' }},
]

import C_ITEMS from '@/utils/items'
import editModal from './editModal'
import authority from '@/common/mixins/authority'
import tableMixins from '@/common/mixins/table'

export default {
  name: 'Contract',
  provide() {
    return {
      parent: this
    }
  },

  components: {
    editModal,
  },

  data() {
    return {
      loading: false,
      isEdit:0,
      pageSizeOptions: ['10', '20', '30', '40', '100'],
      current: 1,
      pageParams: {
        currentPage: 1,
        pageCount: 50,
        perPage: 10,
        totalCount: 0
      },
      columns,
      searchParams: {
        "page": 1,
        "per-page": 10,
        "search": {},
        "sort": ''
      },
      list: [],
      
      current: 1,

      studios: [],

      searchData: {},

      visible: false,
      modalData: {},
      editVisible: false,
      authType:['orginization','room'],
    }
  },
  mixins: [ authority,tableMixins ],
  created() {
    this.getStudio()
  },

  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    closeSearch() {
      this.visible = false
    },
    async getStudio() {
      let res = await this.$store.dispatch('searchBelongStudioAction', {})
      this.studios = res.data
    },

    async getList() {
      if(!this.canIndex){
          this.$message.warning('您暂无权限!!')
          return false
      }
      this.loading = true
      let obj = {}
      let { searchData } = this
      if (searchData) {
        for (let k in searchData) {
          if (k === 'created_at') {
            obj['start_date'] = searchData[k][0]
            obj['end_date'] = searchData[k][1]
          } else {
            obj[k] = searchData[k]
          }
        }
      }
      this.searchParams.search = obj
      let res = await this.$store.dispatch('roomIndexAction', { data: this.searchParams })
      this.list = res.items
      this.pageParams = res._meta
      this.loading = false
    },
    showEditModal(item) {
      if(item){
        this.isEdit = 1
      }else{
        this.isEdit = 0
      }
      this.modalData = item
      this.editVisible = true
    },
    hideEditModal(type) {
      if (type === 1) {
        this.getList()
      }
      this.editVisible = false
    },

    changeStatus(record) {
      if (record.room_status === 1) {
        this.deleteItem(record)
      } else {
        this.recoveryItem(record)
      }
    },
    deleteItem(item) { 
      let that = this
      return new Promise(async (resolve, reject) => {
            let res = await that.$store.dispatch('roomDeleteAction', { data: { room_id: item.room_id } })
            if (res) {
              item.room_status = 0
              resolve(res)
            }
          }).catch(error => console.log(error));
    },
    recoveryItem(item) {
      let that = this
      return new Promise(async (resolve, reject) => {
            let res = await that.$store.dispatch('roomRecoveryAction', { data: { room_id: item.room_id } })
            if (res) {
              item.room_status = 1
              resolve(res)
            }
          }).catch(error => console.log(error));
    },
    handleChange(pagination, filters, sorter){
      if(sorter.order){
          if(sorter.order === "ascend"){
            this.searchParams['sort'] = `${sorter.field}`
          }else{
            this.searchParams['sort'] = `-${sorter.field}`
          }
        }else{
          this.searchParams['sort'] = ''
        }
      this.getList();
    },
  }
}
</script>